import * as THREE from 'three';
export default class BakedModel {
    constructor(model, texture, scale, textureMap) {
        this.textureMap = textureMap;
        this.model = model;
        this.texture = texture;
        this.texture.flipY = false;
        this.texture.encoding = THREE.sRGBEncoding;
        this.material = new THREE.MeshBasicMaterial({
            map: this.texture,
        });
        this.model.scene.traverse((child) => {
            var _a;
            if (child instanceof THREE.Mesh) {
                // Apply scaling if provided
                if (scale)
                    child.scale.set(scale, scale, scale);
                // Check if the child's name is in the texture map
                const meshTexture = (_a = this.textureMap) === null || _a === void 0 ? void 0 : _a[child.name];
                if (meshTexture) {
                    // Ensure the mesh texture has flipY and sRGBEncoding set
                    meshTexture.flipY = false;
                    meshTexture.encoding = THREE.sRGBEncoding;
                    // Apply the specific texture from the texture map
                    child.material = new THREE.MeshBasicMaterial({
                        map: meshTexture,
                    });
                }
                else {
                    // Fallback to the default texture
                    child.material = this.material;
                }
            }
        });
        return this;
    }
    getModel() {
        return this.model.scene;
    }
}
